import styled from 'styled-components';

export const CustomerInfoWrapper = styled.div`
  @media screen and (max-width: 1256px) {
    margin-bottom: 25px;
  }
`;

export const FieldItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const NestedIcon = styled.img``;

export const CustomerInfoText = styled.p`
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  vertical-align: middle;
  margin-left: 7px;
  color: #2d6cdf;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  text-decoration: ${({ $disabled }) => ($disabled ? 'none' : 'underline')};
  opacity: ${({ $disabled }) => ($disabled ? '0.8' : '1')};
`;

export const ContractsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 23px;
`;

export const ContractItem = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #2d6cdf;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.7;
  }
`;
